import { defineStore } from 'pinia';
import type { ActivityType, ProfileType } from '@lw-modules/onboarding-platform';
import { useAccountListStore } from '../account-list-store';
import { useAddAccountStore } from './add-account-store';
import { EntityType } from '~/enums/accounts/entity-type.enum';

export const useSettingsFormStore = defineStore('account-settings-form', {
  state: () => ({
    allowedProfiles: undefined as ProfileType[] | undefined,
    activityType: undefined as ActivityType | undefined,
    profile: undefined as ProfileType | undefined,
    walletId: {
      value: undefined as string | undefined,
      isValid: undefined as boolean | undefined
    }
  }),

  actions: {
    getAllowedProfiles() {
      const { accountOptions } = useAccountListStore();
      const { entityType } = useAddAccountStore();

      if (!this.activityType) {
        this.allowedProfiles = undefined;
        return;
      }

      const activityOptions = accountOptions[this.activityType];

      if (entityType === EntityType.Individual) {
        this.allowedProfiles = activityOptions?.INDIVIDUAL?.profiles;
      } else if (entityType === EntityType.LegalEntity) {
        this.allowedProfiles = activityOptions?.['LEGAL-ENTITY']
          ? (Object.keys(activityOptions['LEGAL-ENTITY'].profiles) as ProfileType[])
          : undefined;
      } else {
        this.allowedProfiles = undefined;
      }

      if (this.allowedProfiles?.length === 1) {
        this.profile = this.allowedProfiles[0];
      }

      if (this.profile && (!this.allowedProfiles || !this.allowedProfiles.includes(this.profile))) {
        this.profile = undefined;
      }
    },

    getAllowedActivities() {
      const { accountOptions } = useAccountListStore();
      const { entityType } = useAddAccountStore();

      if (!entityType) return [];

      return Object.entries(accountOptions)
        .filter(([, option]) => {
          if (entityType === EntityType.Individual) {
            return !!option?.INDIVIDUAL;
          }
          if (entityType === EntityType.LegalEntity) {
            return !!option?.['LEGAL-ENTITY'];
          }
          return false;
        })
        .map(([activityType]) => activityType);
    },

    validateForm(): boolean {
      return (this.walletId.isValid && this.profile && this.activityType) as boolean;
    }
  }
});
